<template>
  <div>
    <div :class="windowResize.width < 1024 ? 'edit-image' : 'absolute z-50 bottom-0 inset-x-0 p-4'">
      <div class="bg-white">
        <div id="mbcCamera" v-show="isShowModeEdition">
          <dwt-capture-image v-if="!isNativeVersion" ref="DWTCaptureImage" :complete="doneCompleted" :resourcesPath="resourcePath"
            @change-editormode="editorMode" @register-event="addMbcEvent" />
          <capture-image v-else-if="showNativeCapture" ref="DWTCaptureImage" :complete="doneCompleted"
            @change-editormode="editorMode" @register-event="addMbcEvent" />
          <footer v-show="step == 0" class="pie">
            <div class="w-full mx-auto flex flex-wrap">
              <div class="w-1/2">
                <button class="w-full remove-outline" @click="activeCropTool">
                  <div :class="textColorClass" class="icon-size">
                    <zt-icon name="crop" />
                  </div>
                  <span :class="textColorClass">{{
                    $t("message.FileUploadComponent.cameraComponent.buttons.manualCrop") }}</span>
                </button>
              </div>
              <div class="w-1/2">
                <button class="w-full remove-outline" @click="rotate">
                  <div :class="textColorClass" class="icon-size">
                    <zt-icon name="box-rotate-right-alt" />
                  </div>
                  <span :class="textColorClass">{{ $t("message.FileUploadComponent.cameraComponent.buttons.rotate")
                  }}</span>
                </button>
              </div>
            </div>
            <div class="w-full mt-10 mx-auto text-center">
              <zt-button @click="close" outlined class="mx-2">
                {{ $t('message.settingsComponent.header.cancelEditMode') }}
              </zt-button>
              <zt-button @click="toSave" class="mx-2">
                {{ $t('message.settingsComponent.header.exitEditMode') }}
              </zt-button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCompressor from 'image-compressor.js';
import { useWindowResize } from '@sichern/ui-elements';
import sichernDwt from '@/components/generics/dwt/DWTCaptureImage.vue'
import CaptureImage from '@/components/generics/image-capture/CaptureImage.vue'


export default {
  inject: ['state', 'mutations'],
  components: { DwtCaptureImage: sichernDwt, CaptureImage },
  data() {
    return {
      actualImageIndex: 0,
      step: 0,
      loading: false,
      disabled: false,
      autoDetection: false,
      countAutoDetection: 0,
      countCrop: 0,
      resetCornerPos: null,
      windowResize: useWindowResize(this),
      doneCompleted: false,
      resourcePath: process.env.VUE_APP_BASE + 'dwt-resources',
      showNativeCapture: false,
    }
  },
  computed: {
    isNativeVersion() {
      return this.$store.getters.getIsNativeVersion
    },
    isInIframe() {
      return window.self !== window.top;
    },
    textColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    isShowModeEdition() {
      return this.state.editMode
    },
    totalDocumentsUpload() {
      return this.state.documentsToUpload.length
    }
  },
  mounted() {
    this.$emit('install', { install: this.showFileChooseWindow })
  },
  methods: {
    editorMode(value) {
      this.mutations.setEditMode(value)
    },
    addMbcEvent() {
      this.$refs.DWTCaptureImage.$on('change-image', () => {
        this.step = 0
      })
      this.$refs.DWTCaptureImage.$on('save-image', async (obj) => {
        this.step = 0
        const blobData = this.isNativeVersion ? obj : obj.result
        await new ImageCompressor(blobData, {
          quality: 0.5,
          maxWidth: 595,
          maxHeight: 842,
          convertSize: 5000000,
          success: async (result) => {
            const testBlob = Object.assign(result, { UrlOnLoad: URL.createObjectURL(result) })
            const numberRandom = Math.floor(Math.random() * 10000)
            const extensionFile = testBlob.type.split('/')[1]

            const mandatoryFile = {
              hash: "",
              name: "Generico",
              alias: "Generico",
              order: 10,
              value: `${numberRandom}.${extensionFile}`,
              mimeType: testBlob.type,
              mandatory: true,
              file: testBlob
            }
            const newFile = {
              alias: 'Generico Agregado ',
              hash: '',
              mandatory: false,
              mimeType: testBlob.type,
              name: `Generico_Agregado_${numberRandom}`,
              order: numberRandom,
              value: `${numberRandom}.${extensionFile}`,
              file: testBlob
            }

            if (testBlob.type === 'image/png' || testBlob.type === 'image/jpeg' || testBlob.type === 'image/jpg' && testBlob.size <= 5000000) {

              if (this.totalDocumentsUpload + 1 <= this.state.metadata.json.min_files) {
                this.mutations.addDocument(mandatoryFile)

              } else {
                this.mutations.addDocument(newFile)

              }
              this.mutations.setActiveOverlay(false)
              this.mutations.setEditMode(false)
            } else {
              this.mutations.setActiveOverlay(false)
              this.$swal({
                type: "error",
                title: this.$t("message.FileUploadComponent.formComponent.selectJpgPng"),
                showConfirmButton: true,
                confirmButtonText: this.$t("message.FileUploadComponent.swal.accept")
              });
            }
            this.close()
          }
        })
      })
    },
    async showFileChooseWindow() {
      if (this.isNativeVersion && !this.showNativeCapture) {
        this.showNativeCapture = true
        await this.$nextTick()
      }
      this.$refs.DWTCaptureImage.openWindow()
    },
    close() {
      this.$refs.DWTCaptureImage.close()
      this.mutations.setEditMode(false)
      this.mutations.setActiveOverlay(false)
    },
    async toSave() {
      await this.$refs.DWTCaptureImage.toSave()
    },
    activeCropTool() {
      this.$refs.DWTCaptureImage.activeCropTool()
    },
    rotate() {
      this.$refs.DWTCaptureImage.rotate()
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 3rem;
}

.text-iframe-primary {
  color: #2694fc !important;
}

.desktop-steps-h {
  height: 50rem;
}

.edit-image {
  position: fixed;
  z-index: 100;
  background-color: #FFF;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.remove-outline {
  outline: none;
}

.kPainterBoxBackground {
  background-color: #FFF !important;
}
</style>